import React, { useState } from 'react';
import { string, bool, number, oneOfType } from 'prop-types';
import { get } from 'lodash';
import { Menu as AntMenu } from 'antd';
import Link from '../../routes/Link';
import { OrderEventsConsumer } from '../../firebase/OrderEvents';
import GetUserSalesChannels from '../../graphql/getUserSalesChannels';
import { AuditDateRangeContext } from '../../contexts/AuditDateRange';
import { Query } from '../../graphql';
import GET_COUNT_ORDERS from '../../../queries/GET_COUNT_ORDERS';
import { withReloadable } from '../../../hoc';
import { HasPermissions, Text, IconBadge, If } from '../../common';
import { urlSisa, urlBase } from './../../../components/utils/changeUrlSisa'

let colorChange = '#1fa02e';

if (urlSisa() == urlBase()) {
    colorChange = '#4daea9';
}

const PendingAuditItem = withReloadable(({ init, end, icon, itemColor, ts }) => {
    return (
        <GetUserSalesChannels>
            {({ data }) => {
                const userSalesChannels = get(data, 'users.results[0].salesChannels');
                const QUERY_VARIABLES = {
                    range: {
                        filter: 'shippingETA.init',
                        init,
                        end
                    },
                    filters: [
                        {
                            field: 'status',
                            value: ['32']
                        },
                        {
                            field: 'salesChannel',
                            value: (userSalesChannels || []).map(({ id }) => id)
                        }
                    ]
                };
                return (
                    <Query query={GET_COUNT_ORDERS} variables={QUERY_VARIABLES} ts={ts}>
                        {({ data }) => {
                            const count = get(data, 'getCountOrders.count', 0);
                            return <IconBadge name={icon} count={count} color={itemColor} />;
                        }}
                    </Query>
                );
            }}
        </GetUserSalesChannels>
    );
}, ['ts']);

const PendingAuditMenuItem = ({ collapsed, icon, label, index, path, currentPathname, ...props }) => {
    const [hovered, toggleHover] = useState(false);
    const isActive = currentPathname === path;
    const itemColor = isActive || hovered ? colorChange : '#ffffff';

    return (
        <HasPermissions to={['audit-monitor:view']}>
            <AntMenu.Item
                className='ant-menu-item'
                key={`pending-audit-menu-item-${index}`}
                onClick={() => this.props.navigate('/audit-monitor')}
                title={<Text text={label} color='white' />}
                onMouseEnter={() => toggleHover(!hovered)}
                onMouseLeave={() => toggleHover(!hovered)}
                {...props}
            >
                <Link href='/audit-monitor' style={{ display: 'flex' }}>
                    <OrderEventsConsumer>
                        {({ ts }) => (
                            <AuditDateRangeContext.Consumer>
                                {({ init, end }) => <PendingAuditItem init={init} end={end} icon={icon} ts={ts} itemColor={itemColor} />}
                            </AuditDateRangeContext.Consumer>
                        )}
                    </OrderEventsConsumer>
                    <If
                        condition={!collapsed}
                        then={(<Text
                            color={itemColor}
                            text={label}
                        />)}
                    />
                </Link>
            </AntMenu.Item>
        </HasPermissions>
    );
};

PendingAuditMenuItem.propTypes = {
    icon: string,
    label: string,
    index: oneOfType([number, string]),
    collapsed: bool,
    path: string,
    currentPathname: string
};
export default PendingAuditMenuItem;
